import Api from './api'
import Vue from "vue";
let cVue = new Vue();
// 数据样式示例
// const allDayPointsRules = {
//   10: ["8640"],
//   15: ["5760"],
//   20: ["4320"],
//   25: ["3456"],
//   30: ["2880"],
//   35: ["2469"],
//   40: ["2169"],
//   45: ["1920"],
//   50: ["1728"],
//   55: ["1571"],
//   60: ["1440"]
// }

// //平台媒介/销售 黄金时段
// const goldPointsNationwideRules = {
//   10: ["900"],
// }
// //地方媒介/销售  黄金时段
// const goldPointsLocalRules = {
//   10: ["900"],
//   15: ["900"],
// }

// //平台媒介/销售 普通时段
// const commonPointsNationwideRules = {
//   10: ["300"],
//   15: ["300"],
//   20: ["300"],
//   25: ["300"],
//   30: ["300"],
//   35: ["300"],
//   40: ["300"],
//   45: ["300"],
//   50: ["300"],
//   55: ["300"],
//   60: ["300"]
// }
// //地方媒介/销售 普通时段
// const commonPointsLocalRules = {
//   10: ["300"],
//   15: ["300"],
// }
// //24小时霸屏
// const allDayTimes = ['10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60']
// //平台媒介/销售 普通时段
// const commonNationwideTimes = ['10', '15', '20', '25', '30', '35', '40', '45', '50', '55', '60']
// //地方媒介/销售 普通时段
// const commonLocalTimes = ['10', '15']
// //平台媒介/销售 黄金时段
// const goldNationwideTimes = ['10']
// //地方媒介/销售 黄金时段
// const goldLocalTimes = ['10', '15']
//上面是前端之前做的数据，现在后端返回的数据在后端已经判断过权限了，所以不需要分本地还是全国
// /adSpace/listSpecificationGroup 使用这个接口需要请求三次并且处理数据
function getDeliveryPeriodConfig () {
  return new Promise((resolve, reject) => {
    Api.getApi('/adSpace/listSpecification').then(res => {
      if (res.data.code == 200) {
        let data = res.data.data
        let deliveryPeriodConfig = {
          allDayPointsRules: {},  //24小时霸屏 次数
          allDayTimes: [],//24小时霸屏 秒数
          goldPointsRules: {}, // 黄金时段 次数
          goldTimes: [],  // 黄金时段 时间秒数
          commonPointsRules:{},//普通时段
          commonTimes:[] //普通时段  
        }
        //进行排序 避免数据混乱
        data.sort((a,b) => {
          return a.playSeconds - b.playSeconds
        })
        //将后端数据转换为前端所需要的格式，因为以前是放在前端的，所以前端格式我不想更改了，直接改后端的
        data.forEach(item => {
          if (item.deliveryPeriod == 3) {
            //获取24小时霸屏数据
            //这里是存在问题的需要判断deliveryPeriodConfig.allDayPointsRules[item.playSeconds]是否已经存在，存在的化就往里面push
            if (deliveryPeriodConfig.allDayPointsRules[item.playSeconds]) {
              deliveryPeriodConfig.allDayPointsRules[item.playSeconds].push(String(item.playCount))
            } else {
              deliveryPeriodConfig.allDayPointsRules[item.playSeconds] = [String(item.playCount)] //antd-vue循环的时候绑定的value问题不转字符串就显示不了后面的单位
              deliveryPeriodConfig.allDayTimes.push(String(item.playSeconds))
            }
          } else if (item.deliveryPeriod == 2) {
            //获取黄金时段数据
            if (deliveryPeriodConfig.goldPointsRules[item.playSeconds]) {
              deliveryPeriodConfig.goldPointsRules[item.playSeconds].push(String(item.playCount))
            } else {
              deliveryPeriodConfig.goldPointsRules[item.playSeconds] = [String(item.playCount)] //antd-vue循环的时候绑定的value问题不转字符串就显示不了后面的单位
              deliveryPeriodConfig.goldTimes.push(String(item.playSeconds))
            }
          } else if (item.deliveryPeriod == 1) {
            // //获取普通时段
            if (deliveryPeriodConfig.commonPointsRules[item.playSeconds]) {
              deliveryPeriodConfig.commonPointsRules[item.playSeconds].push(String(item.playCount))
            } else {
              deliveryPeriodConfig.commonPointsRules[item.playSeconds] = [String(item.playCount)] //antd-vue循环的时候绑定的value问题不转字符串就显示不了后面的单位
              deliveryPeriodConfig.commonTimes.push(String(item.playSeconds))
            }
          }
        })
        resolve(deliveryPeriodConfig)
      } else {
        cVue.$message.warning(res.data.msg?res.data.msg:'获取播放时段信息失败')
        reject (res.data.msg)
      }
    })
  })
  
  
}



export {
  getDeliveryPeriodConfig
}